<div>
    <p-toast></p-toast>

    <p-scrollPanel [style]="{height: 'calc(100vh - 200px)'}">
        <div>
            <div class="flex justify-content-between filter-title-block">
                <span class="filter-title">City</span>
            </div>
            <div class="flex flex-column">
                <input type="text" pInputText [(ngModel)]="city">
            </div>
        </div>
    </p-scrollPanel>

    <hr />
    <div class="flex justify-content-end">
        <button class="btn-darkblue" pButton label="Apply filter" (click)="clickFilter()"></button>
    </div>
</div>
